<template>
  <div class="modal fade create-sale-modal" id="CreateSaleModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Lançar venda</h1>
                  <button type="button" class="btn-close create-sale-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <form ref="formCreateSale" @submit.prevent="createSaleMethod">
                <div class="modal-body ps-30 pe-30">

                  <p>Preencha as informações abaixo para registrar uma nova venda</p>
                  
                  <div class="sale-field sale-field--client mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="client_id" class="form-label fw-medium">Cliente (opcional)</label>
                    <multiselect
                      ref="clientSelect"
                      v-model="selectedClient"
                      :options="getSalesContacts"
                      :searchable="true"
                      :loading="isLoadingClients"
                      :internal-search="false"
                      :custom-label="formatClientOption"
                      :taggable="true"
                      label="phone"
                      track-by="phone"
                      no-options-text="Nenhum cliente encontrado."
                      no-result-text="Nenhum resultado para sua busca."
                      placeholder="Buscar cliente..."
                      @search-change="debouncedFetchClients"
                      @tag="addCustomClient"
                      @close="handleClientBlur"
                      @blur="handleClientBlur"
                      :close-on-select="true"
                      id="client_id"
                    >
                      <template #noOptions>
                        <div>Comece a digitar para buscar clientes.</div>
                      </template>
                      <template #noResult>
                        Cliente não encontrado. Pressione Enter para cadastrar.
                      </template>
                    </multiselect>
                  </div>

                  <div v-if="selectedClient && selectedClient.custom" class="sale-field sale-field--new-client mb-15 mb-mb-15 mb-md-20 col-12">
                    <label class="form-label fw-medium">Cliente não encontrado - preencha os dados</label>
                    <input
                      v-model="newClientName"
                      type="text"
                      class="form-control shadow-none rounded-0 text-black radius-7 mb-10"
                      :class="{ 'is-invalid': clientValidationErrors.name }"
                      placeholder="Nome do cliente *"
                    />
                    <div v-if="clientValidationErrors.name" class="invalid-feedback mb-10">
                      {{ clientValidationErrors.name }}
                    </div>
                    <input
                      v-model="newClientBirthdate"
                      type="text"
                      class="form-control shadow-none rounded-0 text-black radius-7"
                      :class="{ 'is-invalid': clientValidationErrors.birth_date }"
                      placeholder="Data de nascimento (opcional) ex: DD/MM/AAAA"
                      maxlength="10"
                      @input="maskClientBirthdate"
                    />
                    <div v-if="clientValidationErrors.birth_date" class="invalid-feedback">
                      {{ clientValidationErrors.birth_date }}
                    </div>
                  </div>

                  <div class="sale-field sale-field--products mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <div class="product-picker-header">
                      <label for="products" class="form-label fw-medium mb-0">Produtos *</label>
                      <button
                        type="button"
                        class="btn btn-sm scan-product-button"
                        @click="openScannerModal"
                      >
                        <i class="ph ph-barcode"></i>
                        <span>Ler codigo</span>
                      </button>
                    </div>
                    <multiselect
                      ref="productsSelect"
                      v-model="tempProduct"
                      :options="getSalesProductsList"
                      :searchable="true"
                      :loading="isLoadingProducts"
                      :internal-search="false"
                      :custom-label="formatProductOption"
                      :taggable="false"
                      label="name"
                      track-by="id"
                      no-options-text="Nenhum produto encontrado."
                      no-result-text="Nenhum resultado para sua busca."
                      placeholder="Selecione um produto para adicionar..."
                      id="products"
                      @search-change="debouncedFetchProducts"
                      @select="addProductToList"
                    >
                      <template #noOptions>
                        <div>Nenhum produto disponível.</div>
                      </template>
                      <template #noResult>
                        Nenhum produto encontrado
                      </template>
                    </multiselect>

                    <div v-if="selectedProducts.length > 0" class="sale-products-list">
                    <div class="table-responsive selected-products-table">
                      <table class="table table-sm mb-0">
                        <thead>
                          <tr class="bg-light">
                            <th>Produto</th>
                            <th>Quantidade</th>
                            <th>Preço Unit.</th>
                            <th>Subtotal</th>
                            <th class="text-center">Ação</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in selectedProducts" :key="index">
                            <td class="product-name-cell">
                              <button type="button" class="product-name-button" @click="toggleProductTooltip(`sale-${index}`, item, $event)">
                                <span class="selected-product-name">{{ item.product.name }}</span>
                                <small class="selected-product-sku">{{ item.product.sku || '-' }}</small>
                              </button>
                            </td>
                            <td>
                              <div class="quantity-stepper">
                                <button type="button" class="quantity-stepper-button" @click="decreaseProductQuantity(item)">
                                  <i class="ph ph-minus"></i>
                                </button>
                                <input
                                  :value="item.quantity"
                                  type="text"
                                  inputmode="numeric"
                                  pattern="[0-9]*"
                                  min="1"
                                  class="form-control form-control-sm quantity-stepper-input"
                                  @input="updateProductQuantity(item, $event)"
                                  @blur="normalizeProductQuantity(item)"
                                />
                                <button type="button" class="quantity-stepper-button" @click="increaseProductQuantity(item)">
                                  <i class="ph ph-plus"></i>
                                </button>
                              </div>
                            </td>
                            <td>R$ {{ parseFloat(item.product.price).toFixed(2).replace('.', ',') }}</td>
                            <td>R$ {{ calculateSubtotal(item) }}</td>
                            <td class="text-center">
                              <button
                                type="button"
                                class="btn btn-sm btn-danger"
                                @click="removeProductFromList(index)"
                              >
                                <i class="flaticon-delete"></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="sale-total-inline mt-2">
                      <strong>Total: R$ {{ calculateTotal() }}</strong>
                    </div>
                  </div>
                  </div>

                  <div class="sale-field sale-field--notes mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="notes" class="form-label fw-medium">Observações</label>
                    <textarea
                      id="notes"
                      v-model="notes"
                      type="text"
                      class="form-control shadow-none rounded-0 text-black radius-7"
                      placeholder="Digite observações sobre a venda (opcional)"
                      rows="4"
                    ></textarea>
                  </div>

                  <div class="sale-field sale-field--alert col-12">
                    <div id="alertResponseApiCreateSale" class="toast align-items-center text-bg-success border-0 mt-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                      <div class="d-flex">
                        <div class="toast-body fs-md-15 fs-lg-16" id="errorMessageCreateSale">
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                
                <div class="modal-footer">
                  <div class="sale-total-footer">
                    Total: R$ {{ calculateTotal() }}
                  </div>
                  <div class="sale-footer-actions">
                    <button type="button" class="btn btn-danger create-sale-modal" data-bs-dismiss="modal">Cancelar</button>
                    <button type="submit" ref="buttonCreateSale" class="btn btn-success">Registrar venda</button>
                  </div>
                </div>
              </form>
          </div>
      </div>
  </div>

  <div v-if="isScannerModalOpen" class="scanner-modal-backdrop">
    <div class="scanner-modal">
      <div class="scanner-modal-header">
        <div>
          <h2>Ler codigo</h2>
          <p>Aponte a camera para o codigo de barras ou QR Code do produto.</p>
        </div>
        <button type="button" class="scanner-modal-close" @click="closeScannerModal">
          <i class="ph ph-x"></i>
        </button>
      </div>

      <div class="scanner-modal-body">
        <section class="scanner-modal-camera">
          <div class="scanner-video-wrap">
            <video ref="barcodeVideo" class="scanner-video" muted playsinline></video>
            <div class="scanner-target"></div>
          </div>

          <div v-if="pendingScannedProduct" class="scanner-confirmation">
            <div>
              <span class="scanner-confirmation-label">CONFIRME PRODUTO</span>
              <strong>{{ truncateText(pendingScannedProduct.name, 26) }}</strong>
              <small>
                R$ {{ parseFloat(pendingScannedProduct.price).toFixed(2).replace('.', ',') }}
                <span v-if="pendingScannedProduct.sku"> - {{ pendingScannedProduct.sku }}</span>
              </small>
            </div>
            <div class="scanner-confirmation-actions">
              <button type="button" class="btn btn-sm btn-light" @click="rejectScannedProduct">Nao</button>
              <button type="button" class="btn btn-sm btn-success" @click="confirmScannedProduct">Sim</button>
            </div>
          </div>

          <div v-if="scannerMessage" class="scanner-message">
            {{ scannerMessage }}
          </div>
        </section>

        <section class="scanner-modal-products">
          <div class="scanner-products-header">
            <strong>Produtos adicionados</strong>
          </div>

          <div v-if="selectedProducts.length > 0" class="table-responsive selected-products-table scanner-products-table">
            <table class="table table-sm mb-0">
              <thead>
                <tr>
                  <th>Produto</th>
                  <th>Qtd.</th>
                  <th>Subtotal</th>
                  <th class="text-center">Acao</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in selectedProducts" :key="`scanner-${index}`">
                  <td class="product-name-cell">
                    <button type="button" class="product-name-button" @click="toggleProductTooltip(`scanner-${index}`, item, $event)">
                      <span class="selected-product-name">{{ item.product.name }}</span>
                      <small class="selected-product-sku">{{ item.product.sku || '-' }}</small>
                    </button>
                  </td>
                  <td>
                    <div class="quantity-stepper">
                      <button type="button" class="quantity-stepper-button" @click="decreaseProductQuantity(item)">
                        <i class="ph ph-minus"></i>
                      </button>
                      <input
                        :value="item.quantity"
                        type="text"
                        inputmode="numeric"
                        pattern="[0-9]*"
                        min="1"
                        class="form-control form-control-sm quantity-stepper-input"
                        @input="updateProductQuantity(item, $event)"
                        @blur="normalizeProductQuantity(item)"
                      />
                      <button type="button" class="quantity-stepper-button" @click="increaseProductQuantity(item)">
                        <i class="ph ph-plus"></i>
                      </button>
                    </div>
                  </td>
                  <td>R$ {{ calculateSubtotal(item) }}</td>
                  <td class="text-center">
                    <button type="button" class="btn btn-sm btn-danger" @click="removeProductFromList(index)">
                      <i class="flaticon-delete"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-else class="scanner-empty-products">
            Nenhum produto adicionado ainda.
          </div>
        </section>
      </div>

      <div class="scanner-modal-footer">
        <div class="scanner-total-footer">
          Total: R$ {{ calculateTotal() }}
        </div>
        <button type="button" class="btn btn-light" @click="closeScannerModal">Fechar</button>
      </div>
    </div>
  </div>

  <div v-if="confirmationDialog.visible" class="sale-confirmation-backdrop">
    <div class="sale-confirmation-dialog">
      <div class="sale-confirmation-body">
        <div class="sale-confirmation-icon" :class="`sale-confirmation-icon--${confirmationDialog.type}`">
          <i :class="confirmationDialog.icon"></i>
        </div>
        <div class="sale-confirmation-copy">
          <h3>{{ confirmationDialog.title }}</h3>
          <p>{{ confirmationDialog.message }}</p>
        </div>
      </div>
      <div class="sale-confirmation-actions">
        <button type="button" class="btn btn-light" @click="cancelConfirmationDialog">
          {{ confirmationDialog.cancelLabel }}
        </button>
        <button
          type="button"
          class="btn"
          :class="confirmationDialog.confirmButtonClass"
          @click="confirmConfirmationDialog"
        >
          {{ confirmationDialog.confirmLabel }}
        </button>
      </div>
    </div>
  </div>

  <div
    v-if="activeProductPopover"
    class="product-name-popover"
    :class="{ 'product-name-popover--above': activeProductPopover.placement === 'above' }"
    :style="{ left: `${activeProductPopover.left}px`, top: `${activeProductPopover.top}px` }"
  >
    <strong>{{ activeProductPopover.name }}</strong>
    <span>{{ activeProductPopover.sku }}</span>
  </div>
</template>

<script>
import api from '../../config/axios.js';
import { mapGetters, mapActions } from 'vuex';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { BrowserMultiFormatReader } from '@zxing/browser';
import * as bootstrap from 'bootstrap';

export default {
  name: "CreateSaleModal",
  components: {
    Multiselect
  },
  data() {
    return {
      selectedClient: null,
      newClientName: '',
      newClientBirthdate: '',
      clientValidationErrors: {},
      selectedProducts: [],
      tempProduct: null,
      notes: '',
      isSubmittingSale: false,
      allowCloseSaleModal: false,
      pendingSalePayload: null,
      confirmationDialog: {
        visible: false,
        action: null,
        type: 'warning',
        icon: 'ph ph-warning',
        title: '',
        message: '',
        cancelLabel: 'Cancelar',
        confirmLabel: 'Confirmar',
        confirmButtonClass: 'btn-success'
      },
      isLoadingClients: false,
      isLoadingProducts: false,
      lastClientQuery: '',
      clientFetchTimer: null,
      pendingClientQuery: '',
      lastProductQuery: '',
      productFetchTimer: null,
      pendingProductQuery: '',
      barcodeDetector: null,
      zxingReader: null,
      zxingControls: null,
      scannerStream: null,
      scannerFrame: null,
      scannerSessionId: 0,
      isScannerActive: false,
      scannerMessage: '',
      lastScannedCode: '',
      lastScanAt: 0,
      isAddingScannedProduct: false,
      isScannerModalOpen: false,
      pendingScannedProduct: null,
      activeProductTooltip: null,
      activeProductPopover: null
    };
  },
  computed: {
    ...mapGetters([
      'getSalesProductsList',
      'getSalesContacts'
    ])
  },
  watch: {
    selectedClient(client) {
      if (!client || !client.custom) {
        this.newClientName = '';
        this.newClientBirthdate = '';
        this.clientValidationErrors = {};
      }
    }
  },
  methods: {
    ...mapActions([
      'setSalesProductsList',
      'setSalesContacts'
    ]),
    formatProductOption(product) {
      if (!product) return '';

      return `${product.name} (R$ ${parseFloat(product.price).toFixed(2).replace('.', ',')})`;
    },

    formatClientOption(client) {
      return `${client.phone} - ${client.name ? client.name : 'Sem nome'}`;
    },

    addCustomClient(phone) {
      const normalizedPhone = String(phone || '').replace(/\D/g, '');

      if (normalizedPhone.length < 10 || normalizedPhone.length > 11) {
        this.alertResponse('Informe um telefone válido com DDD.', true);
        return;
      }

      this.selectedClient = {
        phone: normalizedPhone,
        name: '',
        custom: true
      };
      this.newClientName = '';
      this.newClientBirthdate = '';
      this.clientValidationErrors = {};
    },

    handleClientBlur() {
      if (this.selectedClient) {
        return;
      }

      const search = String(this.pendingClientQuery || this.$refs.clientSelect?.search || '').trim();
      if (!search) {
        return;
      }

      const normalizedSearch = search.replace(/\D/g, '');
      const existingClient = this.getSalesContacts.find(client =>
        String(client.phone || '').replace(/\D/g, '') === normalizedSearch
        || String(client.name || '').toLowerCase() === search.toLowerCase()
      );

      if (existingClient) {
        this.selectedClient = existingClient;
        this.pendingClientQuery = '';
        return;
      }

      this.addCustomClient(search);
      this.pendingClientQuery = '';
    },

    maskClientBirthdate(event) {
      let value = event.target.value.replace(/\D/g, '').slice(0, 8);

      if (value.length > 2) {
        value = `${value.slice(0, 2)}/${value.slice(2)}`;
      }

      if (value.length > 5) {
        value = `${value.slice(0, 5)}/${value.slice(5)}`;
      }

      this.newClientBirthdate = value;
      event.target.value = value;
    },

    validateCustomClient() {
      this.clientValidationErrors = {};

      if (!this.selectedClient || !this.selectedClient.custom) {
        return true;
      }

      const phone = String(this.selectedClient.phone || '').replace(/\D/g, '');
      const name = String(this.newClientName || '').trim();

      if (phone.length < 10 || phone.length > 11) {
        this.clientValidationErrors.phone = 'Informe um telefone válido com DDD.';
        this.alertResponse(this.clientValidationErrors.phone, true);
      }

      if (!name) {
        this.clientValidationErrors.name = 'Informe o nome do cliente para cadastrá-lo.';
      }

      if (this.newClientBirthdate && this.newClientBirthdate.length !== 10) {
        this.clientValidationErrors.birth_date = 'Informe a data completa no formato DD/MM/AAAA.';
      }

      return Object.keys(this.clientValidationErrors).length === 0;
    },

    addProductToList() {
      if (!this.tempProduct) return;

      const exists = this.selectedProducts.some(item => item.product.id === this.tempProduct.id);
      
      if (exists) {
        this.alertResponse("Este produto já foi adicionado à lista", true);
        this.tempProduct = null;
        return;
      }

      this.selectedProducts.push({
        product: this.tempProduct,
        quantity: 1
      });

      this.tempProduct = null;
    },

    getValidQuantity(value) {
      const quantity = parseInt(String(value).replace(/\D/g, ''), 10);
      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    },

    updateProductQuantity(item, event) {
      const cleanedValue = event.target.value.replace(/\D/g, '');
      event.target.value = cleanedValue;
      item.quantity = cleanedValue ? parseInt(cleanedValue, 10) : 1;
    },

    normalizeProductQuantity(item) {
      item.quantity = this.getValidQuantity(item.quantity);
    },

    increaseProductQuantity(item) {
      item.quantity = this.getValidQuantity(item.quantity) + 1;
    },

    decreaseProductQuantity(item) {
      item.quantity = Math.max(1, this.getValidQuantity(item.quantity) - 1);
    },

    addProductFromScan(product) {
      if (!product) return;

      const existingProduct = this.selectedProducts.find(item => item.product.id === product.id);

      if (existingProduct) {
        existingProduct.quantity = this.getValidQuantity(existingProduct.quantity) + 1;
        return;
      }

      this.selectedProducts.push({
        product,
        quantity: 1
      });
    },

    openScannerModal() {
      this.scannerSessionId += 1;
      const sessionId = this.scannerSessionId;
      this.isScannerModalOpen = true;
      this.pendingScannedProduct = null;
      this.scannerMessage = '';
      this.lastScannedCode = '';
      this.lastScanAt = 0;

      this.$nextTick(() => {
        this.startBarcodeScanner(sessionId);
      });
    },

    closeScannerModal() {
      this.scannerSessionId += 1;
      this.stopBarcodeScanner();
      this.isScannerModalOpen = false;
      this.pendingScannedProduct = null;
      this.scannerMessage = '';
      this.lastScannedCode = '';
      this.lastScanAt = 0;
      this.isAddingScannedProduct = false;
      this.activeProductTooltip = null;
      this.activeProductPopover = null;
    },

    hasSaleDraftData() {
      const hasClient = Boolean(this.selectedClient);
      const hasProducts = this.selectedProducts.length > 0;
      const hasSelectedProduct = Boolean(this.tempProduct);
      const hasNotes = Boolean(this.notes && this.notes.trim());

      return hasClient || hasProducts || hasSelectedProduct || hasNotes;
    },

    showConfirmationDialog(options) {
      this.confirmationDialog = {
        visible: true,
        action: options.action,
        type: options.type || 'warning',
        icon: options.icon || 'ph ph-warning',
        title: options.title,
        message: options.message,
        cancelLabel: options.cancelLabel || 'Cancelar',
        confirmLabel: options.confirmLabel || 'Confirmar',
        confirmButtonClass: options.confirmButtonClass || 'btn-success'
      };
    },

    cancelConfirmationDialog() {
      this.confirmationDialog.visible = false;
      this.confirmationDialog.action = null;
      this.pendingSalePayload = null;
    },

    confirmConfirmationDialog() {
      const action = this.confirmationDialog.action;
      this.confirmationDialog.visible = false;
      this.confirmationDialog.action = null;

      if (action === 'close-sale-modal') {
        this.allowCloseSaleModal = true;
        const modalElement = document.getElementById('CreateSaleModal');

        if (modalElement) {
          const modalInstance = bootstrap.Modal.getOrCreateInstance(modalElement);
          modalInstance.hide();
        }

        return;
      }

      if (action === 'submit-sale' && this.pendingSalePayload) {
        const payload = this.pendingSalePayload;
        this.pendingSalePayload = null;
        this.submitSale(payload);
      }
    },

    resetSaleForm() {
      this.closeScannerModal();
      this.selectedClient = null;
      this.newClientName = '';
      this.newClientBirthdate = '';
      this.clientValidationErrors = {};
      this.selectedProducts = [];
      this.tempProduct = null;
      this.notes = '';
      this.scannerMessage = '';
      this.lastScannedCode = '';
      this.isSubmittingSale = false;
      this.allowCloseSaleModal = false;
      this.pendingSalePayload = null;
      this.confirmationDialog.visible = false;
      this.confirmationDialog.action = null;
    },

    truncateText(value, limit) {
      if (!value) return '';

      const text = String(value);
      return text.length > limit ? `${text.slice(0, limit)}...` : text;
    },

    toggleProductTooltip(key, item, event) {
      if (this.activeProductTooltip === key) {
        this.activeProductTooltip = null;
        this.activeProductPopover = null;
        return;
      }

      const rect = event.currentTarget.getBoundingClientRect();
      const popoverWidth = Math.min(320, window.innerWidth - 24);
      const left = Math.min(Math.max(rect.left, 12), window.innerWidth - popoverWidth - 12);
      const shouldShowAbove = rect.bottom + 88 > window.innerHeight;

      this.activeProductTooltip = key;
      this.activeProductPopover = {
        left,
        top: shouldShowAbove ? rect.top - 8 : rect.bottom + 8,
        placement: shouldShowAbove ? 'above' : 'below',
        name: item.product.name,
        sku: item.product.sku || '-'
      };
    },

    handleProductPopoverOutsideClick(event) {
      if (!this.activeProductPopover) return;

      const clickedInsidePopover = event.target.closest('.product-name-popover');
      const clickedProductButton = event.target.closest('.product-name-button');

      if (!clickedInsidePopover && !clickedProductButton) {
        this.activeProductTooltip = null;
        this.activeProductPopover = null;
      }
    },

    confirmScannedProduct() {
      if (!this.pendingScannedProduct) return;

      const product = this.pendingScannedProduct;
      this.addProductFromScan(product);
      this.pendingScannedProduct = null;
      this.lastScannedCode = '';
      this.lastScanAt = 0;
      this.scannerMessage = `${product.name} adicionado. Continue lendo os proximos codigos.`;
    },

    rejectScannedProduct() {
      this.pendingScannedProduct = null;
      this.lastScannedCode = '';
      this.lastScanAt = 0;
      this.scannerMessage = 'Produto ignorado. Leia outro codigo para continuar.';
    },

    handleScannerConfirmationKeydown(event) {
      if (!this.isScannerModalOpen) return;

      if (event.key === 'Enter') {
        if (!this.pendingScannedProduct) return;

        event.preventDefault();
        event.stopPropagation();
        this.confirmScannedProduct();
      }

      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();

        if (this.pendingScannedProduct) {
          this.rejectScannedProduct();
          return;
        }

        this.closeScannerModal();
      }
    },

    removeProductFromList(index) {
      this.selectedProducts.splice(index, 1);
      this.activeProductTooltip = null;
      this.activeProductPopover = null;
    },

    calculateTotal() {
      const total = this.selectedProducts.reduce((sum, item) => {
        return sum + (parseFloat(item.product.price) * this.getValidQuantity(item.quantity));
      }, 0);
      return total.toFixed(2).replace('.', ',');
    },

    calculateSubtotal(item) {
      const subtotal = parseFloat(item.product.price) * this.getValidQuantity(item.quantity);
      return subtotal.toFixed(2).replace('.', ',');
    },

    async fetchClients(query) {
      if (!query || query.length < 2 || query === this.lastClientQuery) return;

      this.lastClientQuery = query;
      this.isLoadingClients = true;

      try {
        this.setSalesContacts(query);
      } catch (error) {
        console.error('Erro ao buscar clientes:', error);
      } finally {
        this.isLoadingClients = false;
      }
    },

    debouncedFetchClients(query) {
      this.pendingClientQuery = query;

      if (this.clientFetchTimer) {
        clearTimeout(this.clientFetchTimer);
      }

      this.clientFetchTimer = setTimeout(() => {
        this.fetchClients(this.pendingClientQuery);
        this.clientFetchTimer = null;
      }, 600);
    },

    async fetchProducts(query) {
      if (!query || query.length < 2 || query === this.lastProductQuery) return;

      this.lastProductQuery = query;
      this.isLoadingProducts = true;

      try {
        await this.setSalesProductsList(query);
      } catch (error) {
        console.error('Erro ao buscar produtos:', error);
      } finally {
        this.isLoadingProducts = false;
      }
    },

    debouncedFetchProducts(query) {
      this.pendingProductQuery = query;

      if (this.productFetchTimer) {
        clearTimeout(this.productFetchTimer);
      }

      this.productFetchTimer = setTimeout(() => {
        this.fetchProducts(this.pendingProductQuery);
        this.productFetchTimer = null;
      }, 600);
    },

    async startBarcodeScanner(sessionId) {
      this.scannerMessage = '';

      if (!window.isSecureContext) {
        this.scannerMessage = 'Camera bloqueada: acesse por localhost ou HTTPS. Em HTTP com IP da rede o navegador nao libera a camera.';
        return;
      }

      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        this.scannerMessage = 'Este navegador nao permite acessar a camera neste contexto.';
        return;
      }

      try {
        this.isScannerActive = true;
        this.scannerMessage = 'Aponte a camera para o codigo do produto.';

        this.$nextTick(() => {
          if (sessionId !== this.scannerSessionId || !this.isScannerModalOpen) return;

          const video = this.$refs.barcodeVideo;

          if (video) {
            if ('BarcodeDetector' in window) {
              this.startNativeBarcodeScanner(video, sessionId);
            } else {
              this.startZxingBarcodeScanner(video, sessionId);
            }
          }
        });
      } catch (error) {
        this.scannerMessage = 'Nao foi possivel abrir a camera. Verifique permissao e acesso HTTPS.';
        this.stopBarcodeScanner();
      }
    },

    async startNativeBarcodeScanner(video, sessionId) {
      const formats = [
        'qr_code',
        'ean_13',
        'ean_8',
        'code_128',
        'code_39',
        'code_93',
        'upc_a',
        'upc_e',
        'itf',
        'codabar',
        'data_matrix'
      ];

      this.barcodeDetector = new window.BarcodeDetector({ formats });
      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: { ideal: 'environment' }
        },
        audio: false
      });

      if (sessionId !== this.scannerSessionId || !this.isScannerModalOpen || !this.isScannerActive) {
        stream.getTracks().forEach(track => track.stop());
        return;
      }

      this.scannerStream = stream;
      video.srcObject = stream;
      await video.play();

      if (sessionId !== this.scannerSessionId || !this.isScannerModalOpen || !this.isScannerActive) {
        this.stopBarcodeScanner();
        return;
      }

      this.scanBarcodeFrame();
    },

    async startZxingBarcodeScanner(video, sessionId) {
      this.zxingReader = new BrowserMultiFormatReader();
      this.zxingControls = await this.zxingReader.decodeFromConstraints(
        {
          video: {
            facingMode: { ideal: 'environment' }
          },
          audio: false
        },
        video,
        async (result) => {
          if (sessionId !== this.scannerSessionId || !this.isScannerModalOpen) return;
          if (!result || this.isAddingScannedProduct || this.pendingScannedProduct) return;

          const code = String(result.getText()).trim();
          const now = Date.now();

          if (code && (code !== this.lastScannedCode || now - this.lastScanAt > 1800)) {
            this.lastScannedCode = code;
            this.lastScanAt = now;
            await this.addProductByScannedSku(code);
          }
        }
      );

      if (sessionId !== this.scannerSessionId || !this.isScannerModalOpen || !this.isScannerActive) {
        this.stopBarcodeScanner();
      }
    },

    stopBarcodeScanner() {
      this.isScannerActive = false;
      this.barcodeDetector = null;

      if (this.scannerFrame) {
        cancelAnimationFrame(this.scannerFrame);
        this.scannerFrame = null;
      }

      if (this.zxingControls) {
        if (typeof this.zxingControls.stop === 'function') {
          this.zxingControls.stop();
        }
        this.zxingControls = null;
      }

      if (this.zxingReader) {
        this.zxingReader = null;
      }

      if (this.scannerStream) {
        this.scannerStream.getTracks().forEach(track => track.stop());
        this.scannerStream = null;
      }

      const video = this.$refs.barcodeVideo;

      if (video) {
        video.pause();
        if (video.srcObject) {
          video.srcObject.getTracks().forEach(track => track.stop());
        }
        video.srcObject = null;
        video.removeAttribute('src');
        video.load();
      }
    },

    async scanBarcodeFrame() {
      if (!this.isScannerActive) {
        return;
      }

      if (!this.barcodeDetector || this.isAddingScannedProduct || this.pendingScannedProduct) {
        this.scannerFrame = requestAnimationFrame(this.scanBarcodeFrame);
        return;
      }

      const video = this.$refs.barcodeVideo;

      if (!video || video.readyState < 2) {
        this.scannerFrame = requestAnimationFrame(this.scanBarcodeFrame);
        return;
      }

      try {
        const barcodes = await this.barcodeDetector.detect(video);

        if (barcodes.length > 0 && barcodes[0].rawValue) {
          const code = String(barcodes[0].rawValue).trim();
          const now = Date.now();

          if (code && (code !== this.lastScannedCode || now - this.lastScanAt > 1800)) {
            this.lastScannedCode = code;
            this.lastScanAt = now;
            await this.addProductByScannedSku(code);
          }
        }
      } catch (error) {
        this.scannerMessage = 'Nao foi possivel ler este codigo. Tente aproximar melhor a camera.';
      } finally {
        if (this.isScannerActive) {
          this.scannerFrame = requestAnimationFrame(this.scanBarcodeFrame);
        }
      }
    },

    async addProductByScannedSku(sku) {
      this.isAddingScannedProduct = true;
      this.scannerMessage = `Buscando SKU ${sku}...`;

      try {
        const response = await api.axios.get(`/api/products/search/${encodeURIComponent(sku)}`);
        const products = Array.isArray(response.data) ? response.data : [];
        const normalizedSku = sku.toLowerCase();
        const product = products.find(item => String(item.sku || '').toLowerCase() === normalizedSku);

        if (!product) {
          this.scannerMessage = `Produto com SKU ${sku} nao encontrado.`;
          return;
        }

        this.pendingScannedProduct = product;
        this.scannerMessage = '';
      } catch (error) {
        this.scannerMessage = 'Erro ao buscar produto pelo SKU lido.';
      } finally {
        this.isAddingScannedProduct = false;
      }
    },

    createSaleMethod(event) {
      event.preventDefault();

      if (!this.validateCustomClient()) {
        return;
      }

      if (!this.selectedProducts || this.selectedProducts.length === 0) {
        this.alertResponse("Por favor selecione pelo menos um produto", true);
        return;
      }

      const objSaleCreate = {
        client_id: this.selectedClient ? this.selectedClient.phone : null,
        client_name: this.selectedClient && this.selectedClient.custom ? this.newClientName.trim() : null,
        client_birth_date: this.selectedClient && this.selectedClient.custom && this.newClientBirthdate ? this.newClientBirthdate : null,
        items: this.selectedProducts.map(item => ({
          product_id: item.product.id,
          price: item.product.price,
          quantity: item.quantity
        })),
        notes: this.notes || null
      };

      this.pendingSalePayload = objSaleCreate;
      this.showConfirmationDialog({
        action: 'submit-sale',
        type: 'success',
        icon: 'ph ph-check-circle',
        title: 'Confirmar venda',
        message: `Deseja registrar esta venda no valor total de R$ ${this.calculateTotal()}?`,
        cancelLabel: 'Voltar',
        confirmLabel: 'Confirmar venda',
        confirmButtonClass: 'btn-success'
      });
    },

    submitSale(objSaleCreate) {
      const alertResponse = this.alertResponse;
      const buttonCreateSale = this.$refs.buttonCreateSale;
      this.isSubmittingSale = true;
      buttonCreateSale.disabled = true;
      buttonCreateSale.innerHTML = "Registrando...";

      api.axios.post("/api/sales", objSaleCreate).catch((error) => {
        if (error.response?.data != undefined) {
          buttonCreateSale.innerHTML = "Registrar venda";
        }
        console.log("error", error);
        alertResponse(error.response?.data || "Erro ao registrar venda", true);
        buttonCreateSale.disabled = false;
        this.isSubmittingSale = false;
      }).then((response) => {
        if (response != undefined && (response.status == 200 || response.status == 201)) {
          buttonCreateSale.innerHTML = "Venda registrada com sucesso!";
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        } else {
          buttonCreateSale.disabled = false;
          buttonCreateSale.innerHTML = "Registrar venda";
          this.isSubmittingSale = false;
        }
      });
    },

    alertResponse(message, error) {
      const warningMessage = `<i class="flaticon flaticon-warning"></i> ${message}`;
      const successMessage = `<i class="flaticon flaticon-check"></i> ${message}`;

      if (error) {
        document.getElementById("errorMessageCreateSale").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessageCreateSale").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApiCreateSale");
      if (elementAlert) {
        if (error) {
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 7000);
      }
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleScannerConfirmationKeydown, true);
    document.addEventListener('click', this.handleProductPopoverOutsideClick);
    this.setSalesProductsList();

    const modalElement = document.getElementById('CreateSaleModal');
    if (modalElement) {
      // Limpar dados quando o modal fecha
      modalElement.addEventListener('hide.bs.modal', (event) => {
        if (!this.isSubmittingSale && !this.allowCloseSaleModal && this.hasSaleDraftData()) {
          event.preventDefault();
          this.showConfirmationDialog({
            action: 'close-sale-modal',
            type: 'danger',
            icon: 'ph ph-warning-circle',
            title: 'Descartar venda?',
            message: 'Existem informacoes preenchidas nesta venda. Deseja realmente fechar e perder esses dados?',
            cancelLabel: 'Continuar editando',
            confirmLabel: 'Descartar',
            confirmButtonClass: 'btn-danger'
          });
          return;
        }

        this.resetSaleForm();
      });
    }
  },
  unmounted() {
    window.removeEventListener('keydown', this.handleScannerConfirmationKeydown, true);
    document.removeEventListener('click', this.handleProductPopoverOutsideClick);
    this.stopBarcodeScanner();
  }
};
</script>

<style scoped>
.create-sale-modal .modal-content {
  max-height: calc(100vh - 3.5rem);
  overflow: hidden;
}

.create-sale-modal form {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
}

.create-sale-modal .modal-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding-bottom: 20px;
}

.create-sale-modal .modal-footer {
  align-items: center;
  background-color: #ffffff;
  border-top: 1px solid #eef0f7;
  flex-shrink: 0;
  justify-content: flex-end;
  z-index: 2;
}

.sale-total-footer {
  display: none;
}

.sale-footer-actions {
  display: flex;
  gap: 8px;
}

.product-picker-header {
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  margin-bottom: 8px;
}

.scan-product-button {
  align-items: center;
  background-color: var(--splash-success-color);
  border: 0;
  color: #ffffff;
  display: inline-flex;
  gap: 6px;
  min-height: 34px;
  padding: 7px 12px;
}

.scan-product-button:hover,
.scan-product-button:focus {
  background-color: var(--splash-success-color);
  color: #ffffff;
}

.scanner-panel {
  margin-top: 12px;
}

.scanner-video-wrap {
  background: #111827;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}

.scanner-video {
  display: block;
  max-height: 260px;
  object-fit: cover;
  width: 100%;
}

.scanner-target {
  border: 2px solid rgba(255, 255, 255, 0.88);
  border-radius: 8px;
  height: 42%;
  left: 50%;
  max-height: 150px;
  max-width: 360px;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 68%;
}

.scanner-message {
  background: #f8fafc;
  border: 1px solid #edf0f7;
  border-radius: 7px;
  color: #4b5563;
  font-size: 13px;
  margin-top: 8px;
  padding: 9px 11px;
}

.scanner-modal-backdrop {
  align-items: center;
  background: rgba(15, 23, 42, 0.52);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  padding: 24px;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 2100;
}

.scanner-modal {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.22);
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 48px);
  max-width: 1040px;
  overflow: hidden;
  width: min(100%, 1040px);
}

.scanner-modal-header,
.scanner-modal-footer {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
  padding: 16px 20px;
}

.scanner-modal-header {
  border-bottom: 1px solid #edf0f7;
}

.scanner-modal-header h2 {
  color: #1f2937;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.scanner-modal-header p {
  color: #6b7280;
  font-size: 13px;
  margin: 4px 0 0;
}

.scanner-modal-close {
  align-items: center;
  background: transparent;
  border: 0;
  color: #6b7280;
  display: inline-flex;
  font-size: 22px;
  height: 34px;
  justify-content: center;
  width: 34px;
}

.scanner-modal-body {
  flex: 1 1 auto;
  display: grid;
  gap: 18px;
  grid-template-columns: minmax(320px, 0.9fr) minmax(360px, 1.1fr);
  min-height: 0;
  overflow-y: auto;
  padding: 20px;
}

.scanner-modal-camera,
.scanner-modal-products {
  min-width: 0;
}

.scanner-confirmation {
  align-items: center;
  background: #f8fafc;
  border: 1px solid #dfe5ef;
  border-radius: 7px;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  margin-top: 10px;
  padding: 10px 12px;
}

.scanner-confirmation-label {
  color: #6b7280;
  display: block;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}

.scanner-confirmation strong,
.scanner-confirmation small {
  display: block;
}

.scanner-confirmation strong {
  color: #111827;
  font-size: 14px;
  margin-top: 2px;
}

.scanner-confirmation small {
  color: #4b5563;
  font-size: 12px;
  margin-top: 2px;
}

.scanner-confirmation-actions {
  display: flex;
  flex-shrink: 0;
  gap: 8px;
}

.scanner-products-header {
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: flex-start;
  margin-bottom: 10px;
}

.scanner-products-header strong {
  color: #1f2937;
  font-size: 14px;
}

.scanner-products-table {
  border: 1px solid #edf0f7;
  border-radius: 7px;
  max-height: 360px;
}

.scanner-products-table small {
  color: #6b7280;
  display: block;
  font-size: 12px;
  margin-top: 2px;
  max-width: 190px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.scanner-empty-products {
  align-items: center;
  background: #f8fafc;
  border: 1px dashed #dfe5ef;
  border-radius: 7px;
  color: #6b7280;
  display: flex;
  min-height: 132px;
  justify-content: center;
  padding: 18px;
  text-align: center;
}

.scanner-modal-footer {
  border-top: 1px solid #edf0f7;
  background-color: #ffffff;
  justify-content: space-between;
  z-index: 1;
}

.scanner-total-footer {
  color: #1f2937;
  font-size: 15px;
  font-weight: 700;
}

.selected-products-table {
  max-height: 335px;
  overflow: auto;
}

.selected-products-table .table {
  min-width: 690px;
}

.selected-products-table thead th {
  background-color: #ffffff;
  position: sticky;
  top: 0;
  z-index: 1;
}

.quantity-stepper {
  align-items: center;
  border: 1px solid #dfe5ef;
  border-radius: 7px;
  display: inline-flex;
  height: 34px;
  overflow: hidden;
  width: 118px;
}

.quantity-stepper-button {
  align-items: center;
  background: #f8fafc;
  border: 0;
  color: #4b5563;
  display: inline-flex;
  flex: 0 0 34px;
  height: 100%;
  justify-content: center;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.quantity-stepper-button:hover,
.quantity-stepper-button:focus {
  background: #edf0f7;
  color: #111827;
}

.quantity-stepper-input {
  border: 0;
  border-left: 1px solid #dfe5ef;
  border-radius: 0;
  border-right: 1px solid #dfe5ef;
  box-shadow: none;
  flex: 1 1 auto;
  height: 100%;
  min-width: 0;
  padding: 4px;
  text-align: center;
}

.quantity-stepper-input:focus {
  box-shadow: none;
}

.sale-field--products {
  background-color: #f8fafc;
  border: 1px solid #edf0f7;
  border-radius: 8px;
  padding: 14px;
}

.sale-field--products .multiselect {
  background-color: #ffffff;
}

.sale-products-list {
  margin-top: 16px;
}

.sale-products-list .selected-products-table {
  background-color: #ffffff;
  border: 1px solid #edf0f7;
  border-radius: 7px;
}

.selected-product-sku {
  color: #6b7280;
  display: block;
  font-size: 12px;
  margin-top: 3px;
  max-width: 190px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.selected-products-table td:first-child,
.selected-products-table th:first-child {
  min-width: 220px;
  white-space: nowrap;
}

.product-name-cell {
  width: 220px;
}

.product-name-button {
  background: transparent;
  border: 0;
  color: inherit;
  display: block;
  max-width: 190px;
  padding: 0;
  text-align: left;
}

.selected-product-name {
  display: block;
  max-width: 190px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-name-popover {
  background: #111827;
  border-radius: 7px;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.22);
  color: #ffffff;
  max-height: 160px;
  max-width: min(320px, 72vw);
  overflow-y: auto;
  padding: 10px 12px;
  position: fixed;
  transform: none;
  white-space: normal;
  width: min(320px, calc(100vw - 24px));
  z-index: 2200;
}

.product-name-popover::after {
  border-bottom: 7px solid #111827;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  content: "";
  left: 18px;
  position: absolute;
  top: -7px;
}

.product-name-popover--above {
  transform: translateY(-100%);
}

.product-name-popover--above::after {
  border-bottom: 0;
  border-top: 7px solid #111827;
  bottom: -7px;
  top: auto;
}

.product-name-popover strong,
.product-name-popover span {
  display: block;
}

.product-name-popover strong {
  font-size: 13px;
  line-height: 1.35;
}

.product-name-popover span {
  color: #cbd5e1;
  font-size: 12px;
  margin-top: 4px;
  word-break: break-all;
}

.sale-confirmation-backdrop {
  align-items: center;
  background: rgba(15, 23, 42, 0.42);
  display: flex;
  inset: 0;
  justify-content: center;
  padding: 18px;
  position: fixed;
  z-index: 2300;
}

.sale-confirmation-dialog {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 22px 50px rgba(15, 23, 42, 0.24);
  max-width: 430px;
  padding: 22px;
  width: min(430px, 100%);
}

.sale-confirmation-body {
  align-items: center;
  display: flex;
  gap: 14px;
}

.sale-confirmation-icon {
  flex: 0 0 46px;
  align-items: center;
  border-radius: 8px;
  display: flex;
  font-size: 24px;
  height: 46px;
  justify-content: center;
  width: 46px;
}

.sale-confirmation-copy {
  min-width: 0;
}

.sale-confirmation-icon--success {
  background: #e7f7ef;
  color: #168c52;
}

.sale-confirmation-icon--danger {
  background: #fdecef;
  color: #dc3545;
}

.sale-confirmation-icon--warning {
  background: #fff7e6;
  color: #b7791f;
}

.sale-confirmation-dialog h3 {
  color: #2f3152;
  font-size: 19px;
  font-weight: 700;
  margin: 0 0 6px;
}

.sale-confirmation-dialog p {
  color: #6b7280;
  font-size: 14px;
  line-height: 1.45;
  margin: 0;
}

.sale-confirmation-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 18px;
}

.sale-confirmation-actions .btn {
  min-height: 42px;
  min-width: 118px;
}

@media (min-width: 992px) {
  .create-sale-modal .modal-dialog {
    max-width: calc(100vw - 72px);
    width: calc(100vw - 72px);
  }

  .create-sale-modal .modal-body {
    align-items: start;
    column-gap: 28px;
    display: grid;
    grid-template-columns: minmax(300px, 0.58fr) 1px minmax(660px, 1.42fr);
  }

  .create-sale-modal .modal-body::before {
    align-self: stretch;
    background-color: #edf0f7;
    content: "";
    grid-column: 2;
    grid-row: 2 / 6;
    min-height: 100%;
    width: 1px;
  }

  .create-sale-modal .modal-body > p {
    grid-column: 1 / -1;
  }

  .create-sale-modal .sale-field {
    margin-top: 20px !important;
  }

  .create-sale-modal .sale-field--client {
    grid-column: 1;
    grid-row: 2;
  }

  .create-sale-modal .sale-field--products {
    grid-column: 3;
    grid-row: 2 / span 5;
  }

  .create-sale-modal .sale-field--new-client {
    grid-column: 1;
    grid-row: 3;
  }

  .create-sale-modal .sale-field--notes {
    grid-column: 1;
    grid-row: 4;
  }

  .create-sale-modal .sale-field--alert {
    grid-column: 1;
    grid-row: 5;
  }

  .create-sale-modal #notes {
    min-height: 250px;
  }

  .create-sale-modal .modal-footer {
    justify-content: space-between;
  }

  .sale-total-inline {
    display: none;
  }

  .sale-total-footer {
    color: #1f2937;
    display: block;
    font-size: 16px;
    font-weight: 700;
  }

  .selected-products-table {
    max-height: 430px;
  }
}

@media (max-width: 991.98px) {
  .scanner-modal-body {
    grid-template-columns: 1fr;
  }

  .scanner-products-table {
    max-height: 270px;
  }
}

@media (max-width: 767.98px) {
  .create-sale-modal .modal-dialog {
    height: 100dvh;
    margin: 0;
    max-width: 100%;
    width: 100%;
  }

  .create-sale-modal .modal-content {
    border: 0;
    border-radius: 0;
    height: 100dvh;
    max-height: 100dvh;
  }

  .create-sale-modal .modal-body {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }

  .selected-products-table {
    max-height: 285px;
  }

  .quantity-stepper {
    height: 40px;
    width: 132px;
  }

  .quantity-stepper-button {
    flex-basis: 40px;
  }

  .product-picker-header {
    align-items: stretch;
    flex-direction: column;
  }

  .scan-product-button {
    justify-content: center;
    width: 100%;
  }

  .scanner-modal-backdrop {
    padding: 0;
  }

  .scanner-modal {
    border-radius: 0;
    height: 100dvh;
    max-height: 100dvh;
    max-width: 100%;
    width: 100%;
  }

  .scanner-modal-header,
  .scanner-modal-footer,
  .scanner-modal-body {
    padding: 14px;
  }

  .scanner-modal-body {
    flex: 1 1 auto;
  }

  .scanner-confirmation {
    align-items: stretch;
    flex-direction: column;
  }

  .scanner-confirmation-actions .btn {
    flex: 1;
  }

  .sale-confirmation-dialog {
    padding: 20px;
  }

  .sale-confirmation-body {
    align-items: flex-start;
    gap: 12px;
  }

  .sale-confirmation-icon {
    flex-basis: 42px;
    font-size: 22px;
    height: 42px;
    width: 42px;
  }

  .sale-confirmation-actions {
    flex-direction: column-reverse;
  }

  .sale-confirmation-actions .btn {
    width: 100%;
  }
}
</style>
